/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function QuestionFilled16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm-.805-5.782c0-.833.483-1.211 1.113-1.624l.075-.05c.544-.364 1.031-.689 1.031-1.392 0-.518-.343-1.071-1.302-1.071-1.19 0-1.505.833-1.554 1.63l-1.316-.125C5.27 4.996 6.194 3.8 8.147 3.8c1.491 0 2.611.973 2.611 2.268 0 1.14-.567 1.589-1.21 2.023a20.08 20.08 0 0 1-.227.15c-.507.332-.866.567-.866 1.075V9.4h-1.26v-.182Zm-.119 1.42H8.7V12.2H7.076v-1.561Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
